<template>
  <SecondaryButton :classes="'border-brand-mid-gray'">
    <div class="flex items-center px-1 md:px-5">
      <template v-if="field.field_id === 'single_line'">
        <MinusIcon class="text-brand-green w-5 h-5 mr-2" />
      </template>
      <template v-else-if="field.field_id === 'multi_line'">
        <MenuAlt1Icon class="text-brand-green w-5 h-5 mr-2" />
      </template>

      <template v-else-if="field.field_id === 'choice'">
        <DotsVerticalIcon class="text-brand-green w-5 h-5 mr-2" />
      </template>
      <template v-else-if="field.field_id === 'checkbox'">
        <img src="@/assets/icons/checkbox.svg" class="w-5 h-5 mr-2" />
      </template>

      <template v-else-if="field.field_id === 'dropdown'">
        <img src="@/assets/icons/dropdown.svg" class="w-5 h-5 mr-2" />
      </template>

      <template v-else-if="field.field_id === 'ssn'">
        <img src="@/assets/icons/ssn.svg" class="w-5 h-5 mr-2" />
      </template>

      <template v-else-if="field.field_id === 'file'">
        <PaperClipIcon class="text-brand-green w-5 h-5 mr-2" />
      </template>

      <template v-else-if="field.field_id === 'phone'">
        <PhoneIcon class="text-brand-green w-5 h-5 mr-2" />
      </template>

      <template v-else-if="field.field_id === 'date'">
        <CalendarIcon class="text-brand-green w-5 h-5 mr-2" />
      </template>
      <template v-else-if="field.field_id === 'email'">
        <MailIcon class="text-brand-green w-5 h-5 mr-2" />
      </template>
      <template v-else-if="field.field_id === 'agent'">
        <UserGroupIcon class="text-brand-green w-5 h-5 mr-2" />
      </template>
      <template v-else-if="field.field_id === 'state'">
        <LocationMarkerIcon class="text-brand-green w-5 h-5 mr-2" />
      </template>
      <template v-else-if="field.field_id === 'text_display'">
        <img src="@/assets/icons/text_field.svg" class="w-5 h-5 mr-2" />
      </template>
      <template v-else-if="field.field_id === 'date_range'">
        <CalendarIcon class="text-brand-green w-5 h-5 mr-2" />
      </template>
      <template v-else-if="field.field_id === 'address'">
        <LocationMarkerIcon class="text-brand-green w-5 h-5 mr-2" />
      </template>

      <template v-else-if="field.field_id === 'yes_no'">
        <ViewGridAddIcon class="text-brand-green w-5 h-5 mr-2" />
      </template>

      <template v-else-if="field.field_id === 'currency'">
        <CurrencyDollarIcon class="text-brand-green w-5 h-5 mr-2" />
      </template>

      <span class="text-brand-green">{{ field.label }}</span>
    </div>
  </SecondaryButton>
</template>
<script>
import {
  MinusIcon,
  MenuAlt1Icon,
  DotsVerticalIcon,
  PaperClipIcon,
  PhoneIcon,
  CalendarIcon,
  UserGroupIcon,
  MailIcon,
  LocationMarkerIcon,
  ViewGridAddIcon,
  CurrencyDollarIcon
} from "@heroicons/vue/outline"

export default {
  components: {
    MinusIcon,
    MenuAlt1Icon,
    DotsVerticalIcon,
    PaperClipIcon,
    PhoneIcon,
    CalendarIcon,
    UserGroupIcon,
    MailIcon,
    LocationMarkerIcon,
    ViewGridAddIcon,
    CurrencyDollarIcon
  },
  props: {
    field: {
      type: Object
    }
  }
}
</script>
